var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.286.02l-.409 2.25a7.071 7.071 0 00-1.145.475L3.844 1.446 1.42 3.871l1.305 1.881a6.97 6.97 0 00-.475 1.145L0 7.306v3.428l2.25.409c.125.4.291.78.482 1.145L1.42 14.169l2.424 2.425 1.881-1.3c.365.191.753.351 1.152.476l.409 2.25h3.428l.409-2.25a6.97 6.97 0 001.145-.475l1.881 1.299 2.425-2.425-1.306-1.881c.19-.363.35-.742.475-1.139L18 10.734V7.306l-2.257-.409a6.988 6.988 0 00-.468-1.138l1.299-1.888-2.425-2.425-1.881 1.3a6.97 6.97 0 00-1.145-.476L10.714.02H7.286zM9 5.163a3.857 3.857 0 110 7.713 3.857 3.857 0 010-7.713z",
    fillRule: "evenodd"
  })));
}
export default SvgSettings;